// Moving things of the ground floor's working rooms (the Court Police's CCTV screens). Registered for its side effect:
// the screens that live in these rooms import this file. Pure functions of the clock, like fx.ts.
import { registerFx } from './fx';
import { hashStr } from './life';

/** A CCTV picture: a scan bar rolling down, a figure crossing the frame, the feed cutting to another camera now and then. */
registerFx('cctv', (ctx, e, c, h) => {
  const w = e.w ?? 9;
  const hh = e.h ?? 7;
  const t = c.animate ? c.now : 0;
  const feed = Math.floor((t + (h % 9000)) / 7000);
  const s = hashStr(`${h}:${feed}`);
  // a cut to another camera: one frame of snow
  if (c.animate && (t + (h % 9000)) % 7000 < 90) {
    for (let i = 0; i < w * hh; i += 2) {
      ctx.fillStyle = (s + i * 7) % 3 ? '#3b6449' : '#5f8c5a';
      ctx.fillRect(e.x + (i % w), e.y + Math.floor(i / w), 1, 1);
    }
    return;
  }
  // someone walking across this camera's corridor
  const cyc = 5200 + (s % 2600);
  const k = ((t + s) % cyc) / cyc;
  const fx = e.x + Math.round(((s >>> 4) % 2 ? k : 1 - k) * (w - 1));
  const fy = e.y + Math.min(hh - 2, 1 + ((s >>> 8) % Math.max(1, hh - 2)));
  ctx.fillStyle = '#9fd3a4';
  ctx.fillRect(fx, fy, 1, 2);
  // the scan bar
  if (c.animate) {
    const row = Math.floor(((t + h) % 1600) / 1600 * (hh + 3)) - 1;
    if (row >= 0 && row < hh) {
      ctx.fillStyle = 'rgba(200,255,210,0.22)';
      ctx.fillRect(e.x, e.y + row, w, 1);
    }
  }
}, 'ground');
